import React, {Component} from 'react';
import Toast from "../Common/Toast";
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";
import EmptyPic from "../../assets/images/emptypic.png";
import API from "../../services/API";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faDownload, faUpload, faSignInAlt, faWindowClose} from "@fortawesome/free-solid-svg-icons";
import {toast} from "react-toastify";


class CompanyProfile extends Component {
    state = {
        avatar: null,
        file: null,
        pic: EmptyPic,
        title: '',
        national_id: '',
        tel: '',
        website: '',
        address: '',
        staff: [],
        is_verified: 1,
        document_file: null,
        document_description: '',
        document_title: '',
        documents: [],
        staff_last_name: '',
        staff_mobile: '',


    }
    onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            this.setState({
                pic: reader.result,
                file: event.target.files[0]
            })
        };

    }
    onInputChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;
        if(inputName === 'staff_mobile' && inputValue.length > 11) {
            return false
        }
        this.setState({[inputName]: inputValue});

    }
    onButtonClick = () => {
        if (!this.state.title) {
            toast.error('لطفا عنوان شرکت را وارد کنید');
            return false;
        }
        const formData = new FormData();
        const file = this.state.file;
        if (file)
            formData.append('logo', file);
        formData.append('title', this.state.title);
        formData.append('address', this.state.address);
        formData.append('national_id', this.state.national_id);
        formData.append('tel', this.state.tel);
        formData.append('website', this.state.website);
        formData.append('id', this.state.id);

        API.updateCompany(formData)
            .then((response) => {
                toast.success(response.user_message);
                /*                setTimeout(() => {
                                    this.props.history.push("/");
                                }, 2000);*/
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    onDocChange = (event) => {
        this.setState({
            document_file: event.target.files[0]
        })
    }
    onUploadClick = () => {
        const formData = new FormData();
        const file = this.state.document_file;
        if (file) {
            formData.append('document_file', file);
            if (!this.state.document_title) {
                toast.error('لطفا عنوان فایل ارسالی را مشخص کنید');
                return false;
            }
        } else {
            toast.error('لطفا ابتدا یک فایل معتبر انتخاب کنید!');
            return false;
        }

        formData.append('document_title', this.state.document_title);
        formData.append('document_description', this.state.document_description);
        formData.append('id', this.state.id);

        API.updateCompany(formData)
            .then((response) => {
                toast.success(response.user_message);
                API.getCompany()
                    .then((response) => {
                        this.setState(response.results.company);
                        this.setState({
                            document_file: [],
                            document_title: '',
                            document_description: ''
                        })
                    })
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    onStaffClick = () => {
        let mobile = this.state.staff_mobile;
        mobile = '+98' + mobile.substring(1);

        const formData = new FormData();
        formData.append('staff_last_name', this.state.staff_last_name);
        formData.append('staff_mobile', mobile);
        formData.append('id', this.state.id);


        API.updateCompany(formData)
            .then((response) => {

                toast.success(response.user_message);
                API.getCompany()
                    .then((response) => {
                        this.setState(response.results.company);
                        this.setState({
                            staff_last_name: '',
                            staff_mobile: ''
                        })
                    })
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });

    }
    onRemoveStaffClick = (id) => {


        const formData = new FormData();

        formData.append('remove_staff_id', id);
        formData.append('id', this.state.id);


        API.updateCompany(formData)
            .then((response) => {
                toast.success(response.user_message);
                API.getCompany()
                    .then((response) => {
                        this.setState(response.results.company);
                    })
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });

    }

    render() {
        return (
            <React.Fragment>

                <Toast/>
                <section className="container-fluid rtl ">
                    <div className="row">
                        <div className="col-md-3 px-2">
                            <NavBar/>
                        </div>
                        <div className="col-md-9">
                            <TopMenu/>

                            {
                                this.state.is_verified === 0 ?
                                    <div className="alert col-12 alert-danger my-3 small text-center">
                                     شرکت شما هنوز تایید نشده است.
                                        برای تایید مشخصات و مستندات خود را از  کامل کرده و منتظر تایید مدیر سامانه بمانید.

                                    </div>
                                    : ''}


                            <div className="text-center my-5 text-secondary">
                                <h2>
                                    <strong>ویرایش مشخصات شرکت</strong>
                                </h2>

                            </div>

                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home"
                                       role="tab" aria-controls="home" aria-selected="true">اطلاعات شرکت</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile"
                                       role="tab" aria-controls="profile" aria-selected="false">مستندات</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" id="contact-tab" data-toggle="tab" href="#contact"
                                       role="tab" aria-controls="contact" aria-selected="false">کارکنان</a>
                                </li>
                            </ul>
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="home" role="tabpanel"
                                     aria-labelledby="home-tab">
                                    <section className="container rtl  p-3 usual-content ">
                                        <div className="row">
                                            <div className="col-12 p-5">

                                                <img alt="Avatar"
                                                     src={(this.state.avatar && !this.state.file) ? this.state.avatar : this.state.pic}
                                                     width={64} className='rounded-circle'/>
                                                <span className="px-5">
                                                <label className="custom-file-upload">
                                                    انتخاب تصویر پروفایل جدید
                                                 <input type="file" onChange={this.onFileChange}/>
                                                </label>
                                            </span>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="title" name="title"
                                                       placeholder="عنوان"
                                                       value={this.state.title}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="title" className="super-small">عنوان</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="national_id" name="national_id"
                                                       placeholder="شناسه ملی"
                                                       value={this.state.national_id}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="national_id" className="super-small">شناسه ملی</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="tel" name="tel"
                                                       placeholder="شماره تماس"
                                                       value={this.state.tel}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="tel" className="super-small">شماره تماس</label>
                                            </div>
                                            <div className="form-floating col-md-6 mt-4">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="website" name="website"
                                                       placeholder="آدرس وب سایت"
                                                       value={this.state.website}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="website" className="super-small">آدرس وب سایت</label>
                                            </div>

                                            <div className="form-floating col-12 mt-4">

                                        <textarea className="form-control"
                                                  placeholder="آدرس شرکت"
                                                  id="address"
                                                  name="address"
                                                  value={this.state.address ? this.state.address : ''}
                                                  onChange={this.onInputChange}
                                        />

                                                <label htmlFor="description" className="super-small">آدرس شرکت</label>
                                            </div>
                                            {
                                                this.state.is_verified > 0 ?
                                                    <div className="alert col-12 alert-warning my-3 small text-center">
                                                        با ویرایش اطلاعات شرکت شما موقتا از حالت تایید خارج خواهد شد تا
                                                        اطلاعات جدید توسط مدیر سامانه بررسی شود.

                                                    </div>
                                                    : ''}
                                            <div className="col-md-6">
                                                &nbsp;
                                            </div>
                                            <div className="col-md-6 text-left mt-3">
                                                <button className="btn btn-success p-2 w-100" onClick={this.onButtonClick}>
                                                    <FontAwesomeIcon icon={faCheck}/>

                                                    &nbsp;
                                                    ثبت ویرایش اطلاعات
                                                </button>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                                <div className="tab-pane fade" id="profile" role="tabpanel"
                                     aria-labelledby="profile-tab">
                                    <section className="container rtl  p-3 usual-content ">
                                        <h2 className="text-center text-primary mb-4">
                                            مدیریت مستندات
                                        </h2>
                                        <div className="row  mx-md-5 p-md-5 mb-2 border rounded text-center pt-5">
                                            <div className="col-md-4 ">
                                                <label className="custom-file-upload">
                                                    انتخاب فایل
                                                    <input type="file" onChange={this.onDocChange}/>
                                                </label>
                                            </div>
                                            <div className="col-md-8 small mb-3 mt-2 text-secondary">
                                                لطفا مستندات خود را در قالب فایل هایی با پسوند
                                                .doc,
                                                .pdf,
                                                .jpg,
                                                .png
                                                ارسال فرمایید.
                                            </div>
                                            <div className="form-floating col-md-4 mt-2">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="document_title" name="document_title"
                                                       placeholder="عنوان فایل"
                                                       value={this.state.document_title}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="document_title" className="super-small">عنوان فایل</label>
                                            </div>
                                            <div className="form-floating col-md-8">

                                        <textarea className="form-control"
                                                  placeholder="توضیحات"
                                                  id="document_description"
                                                  name="document_description"
                                                  value={this.state.document_description ? this.state.document_description : ''}
                                                  onChange={this.onInputChange}
                                        />

                                                <label htmlFor="document_description" className="super-small">توضیحات</label>
                                            </div>
                                            <div className="col-md-6 text-warning mt-4 super-small">
                                                &nbsp;
                                                {
                                                    this.state.document_file ? this.state.document_file.name : ''
                                                }
                                            </div>
                                            <div className="col-md-6 text-left mt-3">
                                                <button className="btn btn-success p-2 w-100"
                                                        onClick={this.onUploadClick}>
                                                    <FontAwesomeIcon icon={faUpload}/>

                                                    &nbsp;
                                                    ارسال فایل
                                                </button>
                                            </div>
                                        </div>
                                        <div className="border rounded mx-md-5 p-md-5 pt-5">
                                            {
                                                this.state.documents.length > 0 ?

                                                    <h3 className="small text-success text-center">
                                                        فایل های دریافت شده از سمت شما
                                                    </h3>
                                                    :
                                                    <h3 className="small text-danger text-center">
                                                        هنوز هیچ فایلی از سمت شما دریافت نشده است
                                                    </h3>
                                            }
                                            <div className='row text-center py-3 m-auto mt-2 transactions-header  '>
                                                <div className="col-3">عنوان</div>
                                                <div className="col-6">توضیحات</div>
                                                <div className="col-3">دانلود</div>

                                            </div>
                                            {
                                                this.state.documents.map(doc => {

                                                    return (
                                                        <div
                                                            className='row text-center text-dark py-3 m-auto mt-2 transactions-body  '
                                                            key={doc.id}>
                                                            <div className="col-3 fw-bold">
                                                                {doc.title}
                                                            </div>
                                                            <div className="col-6 super-small"> {doc.description}</div>
                                                            <div className="col-3 small">
                                                                <a href={doc.path} target="_blank" rel="noreferrer">
                                                                    <FontAwesomeIcon icon={faDownload}/>&nbsp;
                                                                    دانلود
                                                                </a>
                                                            </div>

                                                        </div>
                                                    )
                                                })


                                            }
                                        </div>
                                    </section>
                                </div>
                                <div className="tab-pane fade" id="contact" role="tabpanel"
                                     aria-labelledby="contact-tab">
                                    <section className="container rtl  p-3 usual-content ">
                                        <h2 className="text-center text-primary mb-4">
                                            مدیریت کارکنان
                                        </h2>
                                        <div className="row  mx-md-5 p-md-5 mb-2 border rounded text-center pt-5">

                                            <div className="form-floating col-md-4 mt-2">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="staff_last_name" name="staff_last_name"
                                                       placeholder="نام خانوادگی"
                                                       value={this.state.staff_last_name}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="staff_last_name" className="super-small">نام خانوادگی</label>
                                            </div>
                                            <div className="form-floating col-md-4 mt-2">
                                                <input type="text"
                                                       className="form-control px-5"
                                                       id="staff_mobile" name="staff_mobile"
                                                       placeholder="شماره همراه"
                                                       value={this.state.staff_mobile}
                                                       onChange={this.onInputChange}/>
                                                <label htmlFor="staff_mobile" className="super-small">شماره همراه</label>
                                            </div>
                                            <div className="col-md-4 text-left mt-3">
                                                <button className="btn btn-success p-2 w-100"
                                                        onClick={this.onStaffClick}>
                                                    <FontAwesomeIcon icon={faSignInAlt}/>

                                                    &nbsp;
                                                    ثبت اطلاعات شخص
                                                </button>
                                            </div>
                                        </div>
                                        <div className="border rounded mx-md-5 p-md-5 pt-5">
                                            {
                                                this.state.staff.length > 0 ?

                                                    <h3 className="small text-success text-center">
                                                        لیست کارکنان
                                                    </h3>
                                                    :
                                                    <h3 className="small text-danger text-center">
                                                        هنوز هیچ شخصی از سمت شما ثبت نشده است
                                                    </h3>
                                            }
                                            <div className='row text-center py-3 m-auto mt-2 transactions-header  '>
                                                <div className="col-3">عنوان</div>
                                                <div className="col-6">شماره همراه</div>
                                                <div className="col-3">حذف</div>

                                            </div>
                                            {
                                                this.state.staff.map(staff => {

                                                    return (
                                                        <div
                                                            className='row text-center text-dark py-3 m-auto mt-2 transactions-body  '
                                                            key={staff.id}>
                                                            <div className="col-3 fw-bold">
                                                                {staff.surname}
                                                            </div>
                                                            <div
                                                                className="col-6 super-small ltr"> {staff.username.replace('+98', '0')}</div>
                                                            <div className="col-3 text-danger pointer" onClick={()=>this.onRemoveStaffClick(staff.id)}>
                                                                <FontAwesomeIcon icon={faWindowClose}/>
                                                            </div>

                                                        </div>
                                                    )
                                                })


                                            }
                                        </div>
                                    </section>
                                </div>
                            </div>




                        </div>

                    </div>
                </section>
            </React.Fragment>
        );
    }

    componentDidMount = () => {
        API.getCompany()
            .then((response) => {
                this.setState(response.results.company)

            })
            .catch((error) => {
                console.log(error.response);
            });
    }
}

export default CompanyProfile;